import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-subarrow",
  "use": "fi-icon-custom-subarrow-usage",
  "viewBox": "0 0 8.824 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.824 10\" id=\"fi-icon-custom-subarrow\">\n  <path id=\"fi-icon-custom-subarrow_Icon_material-subdirectory-arrow-right\" data-name=\"Icon material-subdirectory-arrow-right\" d=\"M14.824,12.471,11.294,16l-.835-.835,2.112-2.106H6V6H7.176v5.882h5.394L10.459,9.776l.835-.835Z\" transform=\"translate(-6 -6)\" fill=\"#646469\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol